import React from 'react';
import { Container, Row, Col, Card, Button, Alert } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import './ErrorPage.css';

const ErrorPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  
  // Get error details from URL parameters
  const error = searchParams.get('error');
  const message = searchParams.get('message');
  
  const getErrorMessage = () => {
    switch (error) {
      case 'authentication_failed':
        return 'Falha na autenticação. Por favor, tente fazer login novamente.';
      case 'correlation_failed':
        return 'Erro na sessão de autenticação. Por favor, tente fazer login novamente.';
      case 'invalid_user_info':
        return 'Informações do usuário inválidas. Por favor, tente fazer login novamente.';
      case 'server_error':
        return message || 'Erro interno do servidor. Por favor, tente novamente mais tarde.';
      default:
        return message || 'Ocorreu um erro inesperado. Por favor, tente novamente.';
    }
  };

  const handleTryAgain = () => {
    // Clear any stored data
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    localStorage.removeItem('userId');
    
    // Redirect to login
    window.location.href = '/';
  };

  return (
    <div className="error-page">
      <Container fluid className="h-100">
        <Row className="h-100 align-items-center justify-content-center">
          <Col xs={12} sm={8} md={6} lg={4} xl={3}>
            <Card className="error-card shadow">
              <Card.Body className="text-center p-4">
                <div className="mb-4">
                  <div className="error-icon mb-3">
                    <i className="bi bi-exclamation-triangle-fill text-warning"></i>
                  </div>
                  <h2 className="error-title">Ops! Algo deu errado</h2>
                  <p className="text-muted">Infelizmente ocorreu um erro durante o processo</p>
                </div>

                <Alert variant="danger" className="mb-4">
                  <Alert.Heading>Erro</Alert.Heading>
                  <p className="mb-0">
                    {getErrorMessage()}
                  </p>
                </Alert>

                <div className="d-grid gap-2">
                  <Button 
                    variant="primary" 
                    size="lg" 
                    onClick={handleTryAgain}
                    className="mb-2"
                  >
                    <i className="bi bi-arrow-clockwise me-2"></i>
                    Tentar Novamente
                  </Button>
                  
                  <Button 
                    variant="outline-secondary" 
                    onClick={() => window.location.href = '/'}
                  >
                    Voltar ao Login
                  </Button>
                </div>

                <div className="mt-4">
                  <small className="text-muted">
                    Se o problema persistir, entre em contato com o suporte.
                  </small>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ErrorPage; 